module.exports = __webpack_public_path__ + "img/14.795fab20.svg";